import React, { useEffect, useState } from "react";

import Sign from '../componets/sign'
import logo2 from '../pinLogo2.png'
import logo from "../images/PINSTACK.jpeg"
import {
    Row,
    Container,
    Col,
    Button,
    Table,
    Spinner,
} from "react-bootstrap";
import API from "../utils/API";
import { useParams, useNavigate } from "react-router-dom";


const reactStringReplace = require('react-string-replace')


export default function Report() {

    const [show, setShow] = useState();

    const [retrieved, setRetrieved] = useState(true);
    const [contractData, setContractData] = useState([])
    const [signCreds, setSignCreds] = useState([])
    const [signedData, setSignedData] = useState([])
    const [sendingContract, setSendingContract] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [gotData, setGotData] = useState(false)
    const [signed, setSigned] = useState(false)
    // const handleShow = () => setShow(true);
    const [msg, setMsg] = useState('Finalizing Contract...');
    const [cs, setCs] = useState(true);
    const [completed, setCompleted] = useState(false)
    const navigate = useNavigate();


    useEffect(() => {
        retrieveData();
        let clickHome = document.getElementById("homePhoto")
        clickHome.addEventListener('click', function () {
            // console.log("going home")
            navigate(`/${id}`);
        })

    }, [signed]);
    useEffect(() => {
        // // console.log(signCreds)
    }, [signed]);
    useEffect(() => {
        console.log(signedData)
    }, [signedData]);



    const { id } = useParams();




    async function retrieveData() {
        setIsLoading(true);
        try {
            const res = await API.getContractData(id);
            if (res.messages?.[0]?.code === 401 || res.response.data[0].fieldData["Signed"] === 1) {
                navigate(`/${id}`);
                return;
            }
            const data = res.response.data[0];
            const contractObj = {
                "ContractType": res.response.data[0].fieldData["ContractType"],
                "Client_Organization": res.response.data[0].fieldData["AccountContacts::Client_Organization"],
                "AlcoholBEOTotalTax": res.response.data[0].fieldData["Alcohol BEOTotal Tax"],
                "AlcoholBEOTotal": res.response.data[0].fieldData["AlcoholBEOTotal"],
                "Balance": res.response.data[0].fieldData["Balance"],
                "BillingAddress": res.response.data[0].fieldData["Billing Address"],
                "BookingContactEmail": res.response.data[0].fieldData["BookingContactEmail"],
                "BookingContactFullName": res.response.data[0].fieldData["BookingContactFullName"],
                "BookingContactPhone": res.response.data[0].fieldData["BookingContactPhone"],
                "BowlingBEOTotalAll": res.response.data[0].fieldData["Bowling BEOTotal All"],
                "BowlingBEOTotal": res.response.data[0].fieldData["Bowling BEOTotal"],
                "BowlingBEOTotalServiceFeeLine": res.response.data[0].fieldData["Bowling BEOTotal ServiceFeeLine"],
                "BowlingBEOTotalTax": res.response.data[0].fieldData["Bowling BEOTotal Tax"],
                "ContractBottomBirthday": res.response.data[0].fieldData["ContractBottom Birthday"],
                "ContractBottomCE": res.response.data[0].fieldData["ContractBottom CE"],
                "ContractTopBirthday": res.response.data[0].fieldData["ContractTop Birthday"],
                "ContractTopCE": res.response.data[0].fieldData["ContractTop CE"],
                "Deposit": res.response.data[0].fieldData["Deposit"],
                "EquipmentBEOTotalAll": res.response.data[0].fieldData["Equipment BEOTotal All"],
                "EquipmentBEOTotal": res.response.data[0].fieldData["Equipment BEOTotal"],
                "EquipmentBEOTotalServiceFeeLine": res.response.data[0].fieldData["Equipment BEOTotal ServiceFeeLine"],
                "EquipmentBEOTotalTax": res.response.data[0].fieldData["Equipment BEOTotal Tax"],
                "EventContractTextBottomSE": res.response.data[0].fieldData["Event Contract Text Bottom SE"],
                "EventContractTextTopSE": res.response.data[0].fieldData["Event Contract Text Top SE"],
                "EventDate": res.response.data[0].fieldData["Event Date"],
                "EventEndDate": res.response.data[0].fieldData["Event End Date"],
                "EventTheme": res.response.data[0].fieldData["Event Theme"],
                "Comments": res.response.data[0].fieldData["Event comments::Comments"],
                "EventEndTime": res.response.data[0].fieldData["EventEndTime"],
                "EventStartTime": res.response.data[0].fieldData["EventStartTime"],
                "FoodBEOTotal": res.response.data[0].fieldData["FoodBEOTotal"],
                "FoodBEOTotalAll": res.response.data[0].fieldData["FoodBEOTotal All"],
                "FoodBEOTotalServiceFeeLine": res.response.data[0].fieldData["FoodBEOTotal ServiceFeeLine"],
                "FoodBEOTotalTax": res.response.data[0].fieldData["FoodBEOTotal Tax"],
                "FunBEOTotalAll": res.response.data[0].fieldData["Fun BEOTotal All"],
                "FunBEOTotal": res.response.data[0].fieldData["Fun BEOTotal"],
                "FunBEOTotalServiceFeeLine": res.response.data[0].fieldData["Fun BEOTotal ServiceFeeLine"],
                "FunBEOTotalTax": res.response.data[0].fieldData["Fun BEOTotal Tax"],
                "GuestCount": res.response.data[0].fieldData["Guest Count"],
                "EventsSignatures::INT1": res.response.data[0].fieldData["EventsSignatures::INT1"],
                "EventsSignatures::INT2": res.response.data[0].fieldData["EventsSignatures::INT2"],
                "EventsSignatures::INT3": res.response.data[0].fieldData["EventsSignatures::INT3"],
                "EventsSignatures::INT4": res.response.data[0].fieldData["EventsSignatures::INT4"],
                "EventsSignatures::INT5": res.response.data[0].fieldData["EventsSignatures::INT5"],
                "EventsSignatures::INT6": res.response.data[0].fieldData["EventsSignatures::INT6"],
                "EventsSignatures::INT7": res.response.data[0].fieldData["EventsSignatures::INT7"],
                "EventsSignatures::INT8": res.response.data[0].fieldData["EventsSignatures::INT8"],
                "EventsSignatures::INT9": res.response.data[0].fieldData["EventsSignatures::INT9"],
                "EventsSignatures::INT10": res.response.data[0].fieldData["EventsSignatures::INT10"],
                "EventsSignatures::INT11": res.response.data[0].fieldData["EventsSignatures::INT11"],
                "EventsSignatures::INT12": res.response.data[0].fieldData["EventsSignatures::INT12"],
                "EventsSignatures::INT13": res.response.data[0].fieldData["EventsSignatures::INT13"],
                "EventsSignatures::INT14": res.response.data[0].fieldData["EventsSignatures::INT14"],
                "EventsSignatures::INT15": res.response.data[0].fieldData["EventsSignatures::INT15"],
                "EventsSignatures::INT16": res.response.data[0].fieldData["EventsSignatures::INT16"],
                "EventsSignatures::INT17": res.response.data[0].fieldData["EventsSignatures::INT17"],
                "EventsSignatures::INT18": res.response.data[0].fieldData["EventsSignatures::INT18"],
                "EventsSignatures::INT19": res.response.data[0].fieldData["EventsSignatures::INT19"],
                "EventsSignatures::INT20": res.response.data[0].fieldData["EventsSignatures::INT20"],
                "LaborBEOTotalAll": res.response.data[0].fieldData["Labor BEOTotal All"],
                "LaborBEOTotal": res.response.data[0].fieldData["Labor BEOTotal"],
                "LaborBEOTotalServiceFeeLine": res.response.data[0].fieldData["Labor BEOTotal ServiceFeeLine"],
                "LaborBEOTotalTax": res.response.data[0].fieldData["Labor BEOTotal Tax"],
                "LineTotal": res.response.data[0].fieldData["Line Total"],
                "LiquorBEOTotalAll": res.response.data[0].fieldData["Liquor BEOTotal All"],
                "LiquorBEOTotalServiceFeeLine": res.response.data[0].fieldData["Liquor BEOTotal ServiceFeeLine"],
                "Location": res.response.data[0].fieldData["Location"],
                "PartyName": res.response.data[0].fieldData["Party Name"],
                "RetailBEOTotal": res.response.data[0].fieldData["Retail BEOTotal"],
                "RetailBEOTotalAll": res.response.data[0].fieldData["Retail BEOTotal All"],
                "RetailBEOTotalServiceFeeLine": res.response.data[0].fieldData["Retail BEOTotal ServiceFeeLine"],
                "RetailBEOTotalTax": res.response.data[0].fieldData["Retail BEOTotal Tax"],
                "RoomBEOTotalAll": res.response.data[0].fieldData["Room BEOTotal All"],
                "RoomBEOTotal": res.response.data[0].fieldData["Room BEOTotal"],
                "RoomBEOTotalServiceFeeLine": res.response.data[0].fieldData["Room BEOTotal ServiceFeeLine"],
                "RoomBEOTotalTax": res.response.data[0].fieldData["Room BEOTotal Tax"],
                "SalesRep": res.response.data[0].fieldData["SalesRep"],
                "SalesRep2": res.response.data[0].fieldData["SalesRep 2"],
                "ServiceFeeTotal": res.response.data[0].fieldData["ServiceFeeTotal"],
                "ServiceFeeTotalTax": res.response.data[0].fieldData["ServiceFeeTotal Tax"],
                "EventsSignatures::SignatureText": res.response.data[0].fieldData["EventsSignatures::SignatureText"],
                "EventsSignatures::Signed": res.response.data[0].fieldData["EventsSignatures::Signed"],
                "SiteContactEmail": res.response.data[0].fieldData["SiteContactEmail"],
                "SiteContactFullName": res.response.data[0].fieldData["SiteContactFullName"],
                "SiteContactPhone": res.response.data[0].fieldData["SiteContactPhone"],
                "Status": res.response.data[0].fieldData["Status"],
                "SubTotalWSF": res.response.data[0].fieldData["SubTotalWSF"],
                "TaxTotal": res.response.data[0].fieldData["Tax Total"],
                "TerritoryName": res.response.data[0].fieldData["Territory Name"],
                "Total": res.response.data[0].fieldData["Total"],
                "TotalPerGuest": res.response.data[0].fieldData["Total Per Guest"],
                "emailHash": res.response.data[0].fieldData["emailHash"],
                "match": res.response.data[0].fieldData["match"],
                "__PK_BEO_ID": res.response.data[0].fieldData["__PK_BEO_ID"],
                "recordID": res.response.data[0].fieldData["recordID"],
                "eventItems": res.response.data[0].portalData.Event_Items,
                "eventPayments": res.response.data[0].portalData.EventPayments,
                "salesRepTerritory": res.response.data[0].fieldData["Territory 2::Sales Rep Primary"],
                "SalesRepEmail": res.response.data[0].fieldData["Territory 2::SalesRepEmail"],
                "resouceItems": res.response.data[0].portalData.EventResources

            };
            setContractData(contractObj);
            setGotData(true);
            correctText(contractObj);
        } catch (error) {
            setRetrieved(false);
        } finally {
            setIsLoading(false);
        }
    }

    function correctText(contractObj) {
        console.log('correct text')
        console.log(contractObj.ContractType)
        console.log(contractObj)
        if (contractObj.ContractType === 'CE') { console.log("in testing") }
        if (contractObj.ContractType === 'CE') {
            try {
                console.log("in trying")
                let contractBottom;

                let contractTop;

                contractBottom = reactStringReplace(contractObj.ContractBottomCE, /(<<Location>>)/g, (match, i) => (
                    <strong key={`location-${i}-${Math.random()}`}>{contractObj.Location}</strong>
                ))
                contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
                    <br key={`br-${i}-${Math.random()}`} />)
                )
                contractTop = reactStringReplace(contractObj.ContractTopCE, /(<<Guest Count>>)/g, (match, i) => (
                    <React.Fragment key={`guestcount-${i}-${Math.random()}`}>{contractObj.GuestCount}</React.Fragment>
                ))
                contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
                    <React.Fragment key={`totalperguest-${i}-${Math.random()}`}>{contractObj.TotalPerGuest}</React.Fragment>
                ))
                contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
                    <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
                )
                let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
                contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
                    <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
                )
                let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
                contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
                    <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
                )

                console.log(contractObj.eventItems.length)
                let eventFix;
                for (let e = 0; e < contractObj.eventItems.length; e++) {
                    // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
                    eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                        <br />)
                    )
                }
                console.log("got here");
                if (contractObj.ContractBottomCE) {
                    const intMatches = contractObj.ContractBottomCE.match(/<<INT[0-9]+>>/g) || [];
                    console.log(intMatches.length);
                    for (let c = 0; c < intMatches.length; c++) {
                        let initV = "<<INT" + (c + 1) + ">>";
                        // Get the field name as used in signedData
                        let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
                        // Check if the value is empty
                        const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
                        contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
                            <input
                                className={`${isEmpty ? " input-border-empty" : " text-center"}`}
                                value={contractObj[`EventsSignatures::INT${c + 1}`] || ""}
                                key={`init-${c}-${i}`}
                                name={initV}
                                size="5"
                                onClick={(e) => initClick(e)}
                                onBlur={(e) => checkInit(e)}
                            />
                        ));
                    }
                } else {
                    console.log("No ContractBottomCE found");
                }
                console.log(contractData)


                setContractData({
                    ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
                });


                setIsLoading(false)
                console.log(isLoading)
            } catch (error) {
                console.log(error)
                setGotData(false)

            }
        }
        else if (contractObj.ContractType === 'SE') {
            console.log("se contract")
            try {
                let contractBottom;
                // // console.log(countInt)
                let contractTop;

                contractBottom = reactStringReplace(contractObj.EventContractTextBottomSE, /(<<Location>>)/g, (match, i) => (
                    <strong key={i}>{contractObj.Location}</strong>
                ))
                contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
                    <br />)
                )
                contractTop = reactStringReplace(contractObj.EventContractTextTopSE, /(<<Guest Count>>)/g, (match, i) => (
                    <>{contractObj.GuestCount}</>)
                )
                contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
                    <>{contractObj.TotalPerGuest}</>)
                )
                contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
                    <strong style={{ textDecoration: 'underline' }} key={i}>{match}</strong>)
                )
                let boldString = `I agree to WAIVe LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
                contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
                    <strong style={{ fontSize: '11px' }} key={i}>{match}</strong>)
                )
                let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
                contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
                    <strong style={{ fontSize: '10px' }} key={i}>{match}</strong>)
                )

                // // console.log(contract.eventItems.length)
                let eventFix;
                for (let e = 0; e < contractObj.eventItems.length; e++) {
                    // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
                    eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                        <br />)
                    )
                }

                let countInt = contractObj.EventContractTextBottomSE.match(/<<INT[0-9]+>>/g)
                for (let c = 0; c < countInt.length; c++) {

                    // // console.log(countInt[c])
                    let initV = "<<INT" + (c + 1) + ">>"
                    // // console.log(initV)
                    contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (

                        <div className="backInitempty inputDiv" id={c}> <input type="text" id={c} name={initV} size="5" onClick={(e) => initClick(e)} onBlur={(e) => checkInit(e)}  ></input></div>
                    )
                    )

                }
                // // console.log(contract)


                setContractData({
                    ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
                });


                setIsLoading(false)
            } catch (error) {
                console.log(error)
                setGotData(false)

            }
        } else if (contractObj.ContractType === 'Birthday') {
            console.log("se contract")
            try {
                let contractBottom;
                // // console.log(countInt)
                let contractTop;

                contractBottom = reactStringReplace(contractObj.ContractBottomBirthday, /(<<Location>>)/g, (match, i) => (
                    <strong key={i}>{contractObj.Location}</strong>
                ))
                contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
                    <br />)
                )
                contractTop = reactStringReplace(contractObj.ContractTopBirthday, /(<<Guest Count>>)/g, (match, i) => (
                    <>{contractObj.GuestCount}</>)
                )
                contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
                    <>{contractObj.TotalPerGuest}</>)
                )
                contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
                    <strong style={{ textDecoration: 'underline' }} key={i}>{match}</strong>)
                )
                let boldString = `I agree to WAIVe LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
                contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
                    <strong style={{ fontSize: '11px' }} key={i}>{match}</strong>)
                )
                let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
                contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
                    <strong style={{ fontSize: '10px' }} key={i}>{match}</strong>)
                )

                // // console.log(contract.eventItems.length)
                let eventFix;
                for (let e = 0; e < contractObj.eventItems.length; e++) {
                    // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
                    eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                        <br />)
                    )
                }

                let countInt = contractObj.ContractBottomBirthday.match(/<<INT[0-9]+>>/g)
                for (let c = 0; c < countInt.length; c++) {

                    // // console.log(countInt[c])
                    let initV = "<<INT" + (c + 1) + ">>"
                    // // console.log(initV)
                    contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (

                        <div className="backInitempty inputDiv" id={c}> <input type="text" id={c} name={initV} size="5" onClick={(e) => initClick(e)} onBlur={(e) => checkInit(e)}  ></input></div>
                    )
                    )

                }
                // // console.log(contractData)


                setContractData({
                    ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
                });


                setIsLoading(false)
            } catch (error) {
                // console.log(error)
                setGotData(false)

            }
        }



    }
    function checkInit(e) {
        const el = e.target;
        console.log(e)
        const val = el.value?.trim() || '';
        const isSignature = el.id === "signature";
        console.log(el.classList)
        if (val.length > 1) {
            if (isSignature) el.classList.remove('backSignempty');
            el.classList.remove('backInitempty');
        } else {
            if (isSignature) el.classList.add('backSignempty');
            el.classList.add('backInitempty');
            checkInputs?.(); // Optional chaining if checkInputs exists
        }
    }
    function initClick(e) {
        // // console.log('initCLick')
        // // console.log(e.target.id)
        // // console.log(e.target.name)

        // // console.log(signCreds);
        // // console.log(initials)  
        if (e.target.id === "signature") {

            let field = e.target.name
            e.target.value = signCreds.name
            // setSignedData({ ...signedData, [field]: signCreds.name });
            // signedData.push({ [field]: signCreds.name })
            setSignedData(prevState => ({
                ...prevState,
                ["EventsSignatures::" + field]: signCreds.name
            }))

        } else {
            let field = e.target.name.replace("<<", 'EventsSignatures::').replace(">>", '')
            e.target.value = signCreds.initials
            // setSignedData({ ...signedData, [field]: signCreds.initials });
            // signedData.push({ [field]: signCreds.initials })
            setSignedData(prevState => ({
                ...prevState,
                [field]: signCreds.initials
            }))
        }

        // setSignedData({ ...signedData, { [field]: signCreds.initials }})
        // // console.log(signedData)
        checkInit(e)
        checkInputs()
    }

    function checkInputs() {
        let inputs = document.getElementsByTagName('input');
        let input = [];
        for (let i = 0; i < inputs.length; ++i) {
            // // console.log(inputs[i].id)

            // if (inputs[i].value.length > 1) {
            //     setCompleted(true)
            // }
            // if (inputs[i].value.length < 1) {
            //     setCompleted(false)
            input.push(inputs[i].value)
        }
        // // console.log('let input')
        // console.log(signedData)
        input.every(validateinputs)
    }


    function validateinputs(input) {
        // // console.log('input.value')
        // // console.log(input)
        // // console.log(typeof input)

        if (typeof input === "undefined") {
            // console.log('undefined')
            setCompleted(false)
            return false
        }
        if (input === "") {
            setCompleted(false);
            return false
        }
        else {
            setCompleted(true);
            return true
        }



    }
    let setFromChild = (data) => {
        // // console.log("setfrom child called")
        // // console.log(data)

        if (data.signName) {
            // console.log("data.signname")
            setSignCreds({ name: data.signName.name, initials: data.signName.initials })
            setSigned(true)
        } else {
            setSignCreds({ name: data.name, initials: data.initials })
            setSigned(true)
        }
    }

    let goToSign = () => {
        document.getElementById("signing").scrollIntoView()
        checkInputs()

    }

    async function submitSignedContract(e) {
        // setSendingContract(true)
         console.log("signedData," )
         console.log(signedData )
        let recordID = contractData.recordID
        let evntID = contractData.__PK_BEO_ID
        let repEmail = contractData.SalesRepEmail
        let partyName = contractData.PartyName
        let eventDate = contractData.EventDate
        await API.postContract({ id, signedData, recordID, evntID, repEmail, partyName, eventDate })
            .then((res) => {
                console.log("api sign a;sf;asfhd")
                console.log(res[0].message)

                if (res[0].message === 'Record is in use by another user') {
                    setCs(false)
                    // setMsg('There was an error submitting your contract. Please contact your PinStack Rep.')
                    setMsg("ERROR:" + res[0].message)
                }
                else {
                    setMsg('Success!')
                    setTimeout(function () {
                        navigate(`/${id}/contractview`);
                    }, 2000);

                }
            })


    }
    async function emailContract() {
        let data = contractData
        await API.getSendEmail(data).then((res) => { console.log(res) })
    }
    function convertToStandardTime(timeString) {
        const timeParts = timeString.split(":");
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(seconds);

        return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "numeric", hour12: true });
    }
    return (
        <div style={{ marginBottom: '30px' }} className="mb-5" id="signing">
            <h1 className="text-light text-center">Contract for {contractData.Client_Organization} on {contractData.EventDate}</h1>
            <Sign sign={data => setFromChild(data)} stat={contractData.Status} />
            <div className="m-auto p-3 text-center">
                {cs ? <Button variant="danger" onClick={() => goToSign()}> Begin Signing </Button> : ''}
            </div>
            <Container id="docu" style={{ width: "794px", padding: "10px", border: "2px solid grey", backgroundColor: 'white' }}>
                {sendingContract ? (
                    <div className="text-center">
                        {cs ? (<>
                            <p>{msg}</p>
                            <img src={logo2} className="App-logo" alt="logo" />

                        </>) : (<>
                            <p>{msg}</p> </>)}

                    </div>

                ) : (<>       {isLoading ? (

                    <div className="text-center">
                        <p>Loading...</p>
                        <img src={logo2} className="App-logo" alt="logo" />
                    </div>
                ) : (
                <>
                    <Row style={{ paddingLeft: "5px" }}>
                        <Col ><img src={logo} width="115px"></img></Col>
                        <Col  ><div style={{ fontSize: '12px', textAlign: 'center' }}><strong>Sales / Catering Contract<br />
                            {contractData.Location} Location</strong>
                            <div style={{ border: "1px solid black", textAlign: 'center', maxWidth: '150px', margin: 'auto' }}>{contractData.__PK_BEO_ID}</div>
                        </div></Col>
                    </Row>
                    <Row style={{ fontSize: "12px", paddingLeft: "5px" }} >
                        <Col style={{ paddingLeft: "5px", paddingRight: "0" }}><p className="mb-0 pb-0">Client Organization</p>
                            <div style={{ border: "1px solid black", borderRight: "0", paddingRight: "0", paddingLeft: "5px" }}>{contractData.Client_Organization}</div>

                        </Col>
                        <Col style={{ paddingRight: "0", paddingLeft: "0" }}><p className="mb-0 pb-0">Event Date</p>
                            <div style={{ border: "1px solid black", borderRight: "0", paddingLeft: "5px" }}>{contractData.EventDate}</div>

                        </Col>
                        <Col style={{ paddingRight: "0", paddingLeft: "0" }}><p className="mb-0 pb-0">Phone</p>
                            <div style={{ border: "1px solid black", borderRight: "0", paddingLeft: "5px", height: "20px" }}>{contractData.BookingContactPhone}</div>

                        </Col>
                        <Col style={{ paddingLeft: "0" }}><p className="mb-0 pb-0">Email</p>
                            <div style={{ border: "1px solid black", paddingLeft: "5px" }}>{contractData.BookingContactEmail}</div>

                        </Col>
                    </Row>
                    <Row style={{ fontSize: "12px", paddingLeft: "5px", paddingRight: '10px' }}>

                        <Col style={{ paddingRight: "0", paddingLeft: "5px" }} md="auto" ><p className="mb-0 pb-0">Address  </p>
                            <div style={{ border: "1px solid black", borderRight: "0", paddingLeft: "5px", paddingRight: '5px' }}>{contractData.BillingAddress}</div>

                        </Col>
                        <Col style={{ paddingRight: "0", paddingLeft: "0" }} ><p className="mb-0 pb-0">Booking Contact  </p>
                            <div style={{ border: "1px solid black", borderRight: "0", paddingLeft: "5px" }}>{contractData.BookingContactFullName}</div>

                        </Col>
                        <Col style={{ paddingRight: "0", paddingLeft: "0" }} ><p className="mb-0 pb-0">Site Contact  </p>
                            <div style={{ border: "1px solid black", borderRight: "0", paddingLeft: "5px" }}>{contractData.SiteContactFullName}</div>

                        </Col>
                        <Col style={{ paddingRight: "5px", paddingLeft: "0" }} md="auto"><p className="mb-0 pb-0">Guest  </p>
                            <div style={{ border: "1px solid black", paddingLeft: "5px" }}>{contractData.GuestCount}</div>

                        </Col>
                    </Row>

                    <Row>

                        <Col style={{ lineHeight: "11px" }} >

                            <span style={{ fontSize: '10px', textAlign: "right" }}>
                                {contractData.ContractTop}
                            </span>
                        </Col>


                    </Row>
                    <Row>

                        <Col style={{ lineHeight: "11px", margin: '10px' }} >
                            <Row style={{ fontSize: "12px", padding: "5px", border: "1px black solid", backgroundColor: "#fafafa" }}>
                                <h3 style={{ textAlign: "center" }}>Event Items</h3>
                                <Col>Food/Service Items</Col>
                                <Col md="auto">Price</Col>
                                <Col md="auto">Qty</Col>
                                <Col md="auto">Total</Col>
                            </Row>
                            <span style={{ fontSize: '10px', textAlign: "left" }}>
                                {contractData.eventItems ? (
                                    <>{
                                        contractData.eventItems.map((item) => (
                                            <Row style={{ fontSize: "12px" }}>
                                                <Col style={{ fontSize: "12px", padding: ' 5px 0', width: '90%' }}>{item["Event Food Items::Display"]}</Col>
                                                <Col md="auto" style={{ paddingTop: ' 5px ', textAlign: "center" }}>{item["Event Food Items::Item PriceUpdated"]}</Col>
                                                <Col md="auto" style={{ paddingTop: ' 5px ', textAlign: "center" }}>{item["Event Food Items::ItemQty"]}</Col>
                                                <Col md="auto" style={{ paddingTop: ' 5px ', textAlign: "center", marginRight: '9px' }}>{item["Event Food Items::Line Total"]}</Col>
                                                <Container style={{ fontSize: "10px", padding: "5px", border: "1px black solid" }} >

                                                    {reactStringReplace(item["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                                                        <br />)
                                                    )}
                                                </Container>
                                            </Row>
                                        )
                                        )
                                    }</>) : ("no items " + contractData.length)}
                            </span>
                        </Col>


                    </Row>
                    {contractData.resouceItems && contractData.resouceItems.length > 0 ? (
                        <Row>
                            <Col style={{ lineHeight: "11px", margin: '10px' }}>
                                <Row style={{ fontSize: "12px", padding: "5px", border: "1px black solid", backgroundColor: "#fafafa" }}>
                                    <h3 style={{ textAlign: "center" }}>Event Space</h3>
                                    <Col md="auto" style={{ width: '40%' }}>Event Space</Col>
                                    <Col md="auto" style={{ width: '12%' }}>Start</Col>
                                    <Col md="auto" style={{ width: '12%' }}>Bar</Col>
                                    <Col md="auto" style={{ width: '12%' }}>Serving</Col>
                                    <Col md="auto" style={{ width: '12%' }}>End</Col>
                                    <Col md="auto" style={{ width: '12%' }}>Set Up Style</Col>
                                </Row>
                                <span style={{ fontSize: '10px', textAlign: "left" }}>

                                    <>
                                        {contractData.resouceItems.map((reso) => (

                                            <Row style={{ fontSize: "12px" }}>
                                                <Col md="auto" style={{ fontSize: "12px", padding: '5px 0', width: '40%' }}>{reso["Event Resources::ItemName"]}</Col>
                                                <Col md="auto" style={{ width: '12%', paddingTop: '5px' }}>{convertToStandardTime(reso["Event Resources::starting_time"])}</Col>
                                                <Col md="auto" style={{ width: '12%', paddingTop: '5px' }}>{reso["Event Resources::Bar"]}</Col>
                                                <Col md="auto" style={{ width: '12%', paddingTop: '5px' }}>{reso["Event Resources::Serving"]}</Col>
                                                <Col md="auto" style={{ width: '12%', paddingTop: '5px' }}>{convertToStandardTime(reso["Event Resources::ending_time"])}</Col>
                                                <Col md="auto" style={{ width: '12%', paddingTop: '5px' }}>{reso["Event Resources::SetupStyle"]}</Col>
                                                <Container style={{ fontSize: "10px", padding: "5px", border: "1px black solid" }}>
                                                    {reactStringReplace(reso["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                                                        <br />
                                                    ))}
                                                </Container>
                                            </Row>
                                        ))}
                                    </>

                                </span>
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}
                    <Row style={{ fontSize: "12px", padding: "5px", border: "1px black solid", backgroundColor: "#fafafa" }}>
                        <h3 style={{ textAlign: "center" }}>Comments</h3>

                    </Row>
                    <Row style={{ fontSize: "12px" }}>
                        <Col>{contractData.Comments}</Col>
                    </Row>
                    <Row style={{ padding: '10px' }} className="justify-content-end">


                        <Table striped bordered hover size="sm" style={{ fontSize: "12px", width: "250px" }}>
                            <thead>

                            </thead>
                            <tbody>
                                <tr className="text-end">
                                    <td >SubTotal</td>


                                    <td style={{ width: "150px" }} >${(Math.round(contractData.LineTotal * 100) / 100).toFixed(2)}</td>
                                </tr>
                                <tr className="text-end">
                                    <td>Service Fee</td>

                                    <td>${(Math.round(contractData.ServiceFeeTotal * 100) / 100).toFixed(2)}</td>
                                </tr>
                                <tr className="text-end">
                                    <td>Tax</td>

                                    <td>${(Math.round(contractData.TaxTotal * 100) / 100).toFixed(2)}</td>
                                </tr>
                                <tr className="text-end">
                                    <td>Total</td>





                                    <td>${(Math.round(contractData.Total * 100) / 100).toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Row>
                    <Row>

                        <Col id="signing" style={{ lineHeight: "11px" }} >
                            <span style={{ fontSize: '10px', textAlign: "right" }}>
                                {contractData.ContractBottom}
                            </span>
                        </Col>


                    </Row>
                    <Row className="pt-5" style={{ fontSize: "12px", paddingLeft: "25px" }}>
                        <Col sm={4} className="d-flex flex-column">
                            <input
                                type="text"
                                name="signatureText"
                                id="signature"
                                size="25"
                                className="signInput backSignempty"
                                onClick={(e) => initClick(e)}
                                onBlur={(e) => checkInit(e)}
                            />
                            <small className="text-muted mt-1">Event Contact Signature</small>
                        </Col>

                        <Col sm={4} className="d-flex flex-column justify-content-start">
                            <div className="signInput">{new Date().toLocaleString()}</div>
                            <small className="text-muted mt-1">Date</small>
                        </Col>

                        <Col sm={4} className="d-flex flex-column justify-content-start">
                            <div className="signInput">{signCreds.name}</div>
                            <small className="text-muted mt-1">Print Name</small>
                        </Col>
                    </Row>

                    {/* Business Name / Event Date row */}
                    <Row className="pt-3" style={{ fontSize: "12px", paddingLeft: "25px" }}>
                        <Col sm={6} className="d-flex flex-column">
                            <div className="signInput">{contractData.Client_Organization}</div>
                            <small className="text-muted mt-1">Business Name</small>
                        </Col>

                        <Col sm={6} className="d-flex flex-column">
                            <div className="signInput">{contractData.EventDate}</div>
                            <small className="text-muted mt-1">Date & Time of Event</small>
                        </Col>
                    </Row>

                </>
                )}</>)}




            </Container >

            <Container className="text-center mt-3 mb-30">
                <Row className="justify-content-center mt-3 mb-30">
                    {completed ? (<>

                        <Col md="auto"> </Col>
                        <Col xs lg="2">
                            {cs ? <Button variant="danger" onClick={(e) => submitSignedContract(e)}>Submit Signed Contract</Button> : ''}
                        </Col>    <Col md="auto"> </Col></>
                    ) : ("")}
                </Row>


            </Container>
        </div >
    )
}
